import * as service from './service'
import { HTTP_CODE } from '@/utils/request'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'longPartnerBlessingValue',
  state: {
    detailsData: {}
  },
  effects: {
    * getDetails ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getDetails, payload)
        if (res.data.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        }
        return res.data
      } catch (err) {
        console.log(err, 'errrrrrr')
        return err
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
